module.exports = __webpack_public_path__ + "img/mirror18.a9d44252.jpg";